import React, {useState} from "react";
import cogoToast from "cogo-toast";

const Tab3 = ({tab, setTab, userData, addTabData}) => {

    const [employToggle, setEmployToggle] = useState(userData?.tab3?.employmentData?.status === "EMPLOYED" || userData?.tab3?.employmentData?.status === "SELF_EMPLOYED");

    /* Employment Extra fields Visibility toggle */
    const employmentChange = e => {
        const val = e.currentTarget.value;
        setEmployToggle(val === "EMPLOYED" || val === "SELF_EMPLOYED");
    }

    const handleSubmit = e =>  {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        const formData = new FormData(form);
        const obj = Object.fromEntries(formData.entries());
        const tab3Data = {};



        /* Enployment Data Values Check */
        if (obj.status && !employToggle){
            tab3Data.employmentData = {
                "status" : obj.status
              }
        }
        else if (obj.status && employToggle && obj.address && obj.city && obj.company && obj.country && obj.position && obj.state && obj.type && obj.zip){
            tab3Data.employmentData = {
                "address" : obj.address,
                "city" : obj.city,
                "company" : obj.company,
                "country" : obj.country,
                "position" : obj.position,
                "state" : obj.state,
                "status" : obj.status,
                "type" : obj.type,
                "zip" : obj.zip
              }
        }
        else if (obj.status && employToggle){
            cogoToast.error("Employment Information fields can not to be partially filled");
            return
        }

        /* Investment profile Data Values Check */
        if (obj.annualIncome && obj.investmentExperience && obj.investmentObjectives && obj.networthLiquid && obj.networthTotal && obj.riskTolerance && obj.taxRate){
            tab3Data.investmentData = {
                "annualIncome" : +obj.annualIncome,
                "investmentExperience" : obj.investmentExperience,
                "investmentObjectives" : obj.investmentObjectives,
                "networthLiquid" : +obj.networthLiquid,
                "networthTotal" : +obj.networthTotal,
                "riskTolerance" : obj.riskTolerance,
                "taxRate" : +obj.taxRate
              }
        }
        else if (obj.annualIncome || obj.investmentExperience || obj.investmentObjectives || obj.networthLiquid || obj.networthTotal || obj.riskTolerance || obj.taxRate){
            cogoToast.error("Investment profile Information fields can not to be partially filled");
            return
        }

        /* Compliance & AML Data Values Check */
        if (obj.fundingSources && obj.investmentHistory12M && obj.transferFrequencyPerMonth && obj.transferTotalExpected){
            // Get Multiple select options
            const options = Array.from(document.querySelector("select[name='fundingSources']").selectedOptions);
            tab3Data.complianceData = {
                "fundingSources" : options.map(opt => opt.value),
                "investmentHistory12M" : +obj.investmentHistory12M,
                "transferFrequencyPerMonth" : +obj.transferFrequencyPerMonth,
                "transferTotalExpected" : +obj.transferTotalExpected
              }
        }
        else if (obj.fundingSources || obj.investmentHistory12M || obj.transferFrequencyPerMonth || obj.transferTotalExpected){
            cogoToast.error("Compliance & AML Information fields can not to be partially filled");
            return
        }

        addTabData({tab3: tab3Data});
        setTab(4);
    }


    return  <form
                onSubmit={handleSubmit} 
                className="form mt-0 mt-lg-10" 
            >
                <div 
                    className="pb-5" 
                    data-wizard-type="step-content" 
                    data-wizard-state={tab === 3 ? "current" : ""}
                >
                    <div className="mb-10 h3 font-weight-bold text-dark">User Employment Details</div>
                    
                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>Employment status</label>
                        <select 
                            name="status" 
                            defaultValue={userData?.tab3?.employmentData?.status}
                            className="form-control form-control-solid form-control-lg"
                            onChange={employmentChange}
                        >
                            <option value="">Select</option>
                            <option value="EMPLOYED">Employed</option>
                            <option value="RETIRED">Retired</option>
                            <option value="STUDENT">Student</option>
                            <option value="UNEMPLOYED">Not Employed</option>
                            <option value="SELF_EMPLOYED">Self Employed</option>
                        </select>
                    </div>
                    {/* <!--end::Input--> */}

                    <div className={employToggle ? "" : "d-none"}>

                        <div className="row">
                            <div className="col-xl-6">
                                {/* <!--begin::Input--> */}
                                <div className="form-group">
                                    <label>Employer company name</label>
                                    <input 
                                        type="text" 
                                        defaultValue={userData?.tab3?.employmentData?.company}
                                        className="form-control form-control-solid form-control-lg" 
                                        name="company"
                                    />
                                </div>
                                {/* <!--end::Input--> */}
                            </div>
                            <div className="col-xl-6">
                                {/* <!--begin::Select--> */}
                                <div className="form-group">
                                    <label>Type of employment</label>
                                    <select 
                                        name="type" 
                                        defaultValue={userData?.tab3?.employmentData?.type}
                                        className="form-control form-control-solid form-control-lg"
                                    >
                                        <option value="">Select</option>
                                        <option value="AGRICULTURE">Agriculture, Forestry, Fishing and Hunting</option>
                                        <option value="MINING">Mining, Quarrying, and Oil and Gas Extraction</option>        
                                        <option value="UTILITIES">Utilities</option>
                                        <option value="CONSTRUCTION">Construction</option>
                                        <option value="MANUFACTURING">Manufacturing</option>
                                        <option value="WHOLESALE">Wholesale Trade</option>
                                        <option value="RETAIL">Retail Trade</option>
                                        <option value="TRANSPORT">Transportation and Warehousing</option>
                                        <option value="INFORMATION">Information</option>
                                        <option value="FINANCE">Finance and Insurance</option>
                                        <option value="REAL_ESTATE">Real Estate and Rental and Leasing</option>
                                        <option value="PROFESSIONAL">Professional, Scientific, and Technical Services</option>
                                        <option value="MANAGEMENT">Management of Companies and Enterprises</option>
                                        <option value="EDUCATION">Educational Services</option>
                                        <option value="HEALTH">Health Care and Social Assistance</option>
                                        <option value="ART">Arts, Entertainment, and Recreation</option>
                                        <option value="FOOD">Accommodation and Food Services</option>
                                        <option value="PUBLIC">Public Administration</option>
                                        <option value="WASTE">Administrative and Support and Waste Management and Remediation Services</option>
                                    </select>
                                </div>
                                {/* <!--end::Select--> */}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xl-6">
                                {/* <!--begin::Input--> */}
                                <div className="form-group">
                                    <label>Position at employment company</label>
                                    <select 
                                        name="position" 
                                        defaultValue={userData?.tab3?.employmentData?.position}
                                        className="form-control form-control-solid form-control-lg"
                                    >
                                        <option value="">Select</option>
                                        <option value="ACCOUNTANT">Accountant/CPA/Bookkeeper/Controller</option>
                                        <option value="ACTUARY">Actuary</option>
                                        <option value="ADJUSTER">Adjuster</option>
                                        <option value="ADMINISTRATOR">Administrator</option>
                                        <option value="ADVERTISER">Advertiser/Marketer/PR Professional</option>
                                        <option value="AGENT">Agent</option>
                                        <option value="ATC">Air Traffic Controller</option>
                                        <option value="AMBASSADOR">Ambassador/Consulate Professional</option>
                                        <option value="ANALYST">Analyst</option>
                                        <option value="APPRAISER">Appraiser</option>
                                        <option value="ARCHITECT">Architect/Designer</option>
                                        <option value="ARTIST">Artist/Performer/Actor/Dancer</option>
                                        <option value="ASSISTANT">Assistant</option>
                                        <option value="ATHLETE">Athlete</option>
                                        <option value="ATTENDANT">Attendant</option>
                                        <option value="ATTORNEY">Attorney/Judge/Legal Professional</option>
                                        <option value="AUCTIONEER">Auctioneer</option>
                                        <option value="AUDITOR">Auditor</option>
                                        <option value="BARBER">Barber/Beautician/Hairstylist</option>
                                        <option value="BROKER">Broker</option>
                                        <option value="BUSINESS_EXEC">Business Executive (VP, Director, etc.)</option>
                                        <option value="BUSINESS_OWNER">Business Owner</option>
                                        <option value="CAREGIVER">Caregiver</option>
                                        <option value="CARPENTER">Carpenter/Construction Worker</option>
                                        <option value="CASHIER">Cashier</option>
                                        <option value="CHEF">Chef/Cook</option>
                                        <option value="CHIROPRACTOR">Chiropractor</option>
                                        <option value="CIVIL">Civil Servant</option>
                                        <option value="CLERGY">Clergy</option>
                                        <option value="CLERK">Clerk</option>
                                        <option value="COMPLIANCE">Compliance/Regulatory Professional</option>
                                        <option value="CONSULTANT">Consultant</option>
                                        <option value="CONTRACTOR">Contractor</option>
                                        <option value="COUNSELOR">Counselor/Therapist</option>
                                        <option value="CUSTOMER_SERVICE">Customer Service Representative</option>
                                        <option value="DEALER">Dealer</option>
                                        <option value="DEVELOPER">Developer</option>
                                        <option value="DISTRIBUTOR">Distributor</option>
                                        <option value="DOCTOR">Doctor/Dentist/Veterinarian/Surgeon</option>
                                        <option value="DRIVER">Driver</option>
                                        <option value="ENGINEER">Engineer</option>
                                        <option value="EXAMINER">Examiner</option>
                                        <option value="EXTERMINATOR">Exterminator</option>
                                        <option value="FACTORY">Factory/Warehouse Worker</option>
                                        <option value="FARMER">Farmer/Rancher</option>
                                        <option value="FINANCIAL">Financial Planner</option>
                                        <option value="FISHERMAN">Fisherman</option>
                                        <option value="FLIGHT">Flight Attendant</option>
                                        <option value="HR">Human Resources Professional</option>
                                        <option value="IMPEX">Importer/Exporter</option>
                                        <option value="INSPECTOR">Inspector/Investigator</option>
                                        <option value="INTERN">Intern</option>
                                        <option value="INVESTMENT">Investment Advisor/Investment Manager</option>
                                        <option value="INVESTOR">Investor</option>
                                        <option value="IT">IT Professional/IT Associate</option>
                                        <option value="JANITOR">Janitor</option>
                                        <option value="JEWELER">Jeweler</option>
                                        <option value="LABORER">Laborer</option>
                                        <option value="LANDSCAPER">Landscaper</option>
                                        <option value="LENDING">Lending Professional</option>
                                        <option value="MANAGER">Manager</option>
                                        <option value="MECHANIC">Mechanic</option>
                                        <option value="MILITARY">Military, Officer or Associated</option>
                                        <option value="MORTICIAN">Mortician/Funeral Director</option>
                                        <option value="NURSE">Nurse</option>
                                        <option value="NUTRITIONIST">Nutritionist</option>
                                        <option value="OFFICE">Office Associate</option>
                                        <option value="PHARMACIST">Pharmacist</option>
                                        <option value="PHYSICAL">Physical Therapist</option>
                                        <option value="PILOT">Pilot</option>
                                        <option value="POLICE">Police Officer/Firefighter/Law Enforcement Professional</option>
                                        <option value="POLITICIAN">Politician</option>
                                        <option value="PM">Project Manager</option>
                                        <option value="REP">Registered Rep</option>
                                        <option value="RESEARCHER">Researcher</option>
                                        <option value="SAILOR">Sailor/Seaman</option>
                                        <option value="SALES">Salesperson</option>
                                        <option value="SCIENTIST">Scientist</option>
                                        <option value="SEAMSTRESS">Seamstress/Tailor</option>
                                        <option value="SECURITY">Security Guard</option>
                                        <option value="SOCIAL">Social Worker</option>
                                        <option value="TEACHER">Teacher/Professor</option>
                                        <option value="TECHNICIAN">Technician</option>
                                        <option value="TELLER">Teller</option>
                                        <option value="TRADESPERSON">Tradesperson/Craftsperson</option>
                                        <option value="TRAINER">Trainer/Instructor</option>
                                        <option value="TRANSPORTER">Transporter</option>
                                        <option value="UNDERWRITER">Underwriter</option>
                                        <option value="WRITER">Writer/Journalist/Editor</option>
                                    </select>
                                </div>
                                {/* <!--end::Input--> */}
                            </div>
                            <div className="col-xl-6">
                                    
                                {/* <!--begin::Input--> */}
                                <div className="form-group">
                                    <label>Company Address</label>
                                    <input 
                                        type="text" 
                                        defaultValue={userData?.tab3?.employmentData?.address}
                                        className="form-control form-control-solid form-control-lg" 
                                        name="address"
                                    />
                                </div>
                                {/* <!--end::Input--> */}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xl-6">
                                {/* <!--begin::Input--> */}
                                <div className="form-group">
                                    <label>Zip / Postcode</label>
                                    <input 
                                        type="text" 
                                        defaultValue={userData?.tab3?.employmentData?.zip}
                                        className="form-control form-control-solid form-control-lg" 
                                        name="zip"
                                    />
                                </div>
                                {/* <!--end::Input--> */}
                            </div>
                            <div className="col-xl-6">
                                {/* <!--begin::Input--> */}
                                <div className="form-group">
                                    <label>City</label>
                                    <input 
                                        type="text" 
                                        defaultValue={userData?.tab3?.employmentData?.city}
                                        className="form-control form-control-solid form-control-lg" 
                                        name="city"
                                    />
                                </div>
                                {/* <!--end::Input--> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-6">
                                {/* <!--begin::Input--> */}
                                <div className="form-group">
                                    <label>State / Province</label>
                                    <input 
                                        type="text" 
                                        defaultValue={userData?.tab3?.employmentData?.state}
                                        className="form-control form-control-solid form-control-lg" 
                                        name="state"
                                    />
                                </div>
                                {/* <!--end::Input--> */}
                            </div>
                            <div className="col-xl-6">
                                {/* <!--begin::Select--> */}
                                <div className="form-group">
                                    <label>Country</label>
                                    <select 
                                        name="country" 
                                        defaultValue={userData?.tab3?.employmentData?.country}
                                        className="form-control form-control-solid form-control-lg"
                                    >
                                        <option value="">Select</option>
                                        <option value="AFG">Afghanistan</option>
                                        <option value="ALA">Åland Islands</option>
                                        <option value="ALB">Albania</option>
                                        <option value="DZA">Algeria</option>
                                        <option value="ASM">American Samoa</option>
                                        <option value="AND">Andorra</option>
                                        <option value="AGO">Angola</option>
                                        <option value="AIA">Anguilla</option>
                                        <option value="ATA">Antarctica</option>
                                        <option value="ATG">Antigua and Barbuda</option>
                                        <option value="ARG">Argentina</option>
                                        <option value="ARM">Armenia</option>
                                        <option value="ABW">Aruba</option>
                                        <option value="AUS">Australia</option>
                                        <option value="AUT">Austria</option>
                                        <option value="AZE">Azerbaijan</option>
                                        <option value="BHS">Bahamas</option>
                                        <option value="BHR">Bahrain</option>
                                        <option value="BGD">Bangladesh</option>
                                        <option value="BRB">Barbados</option>
                                        <option value="BLR">Belarus</option>
                                        <option value="BEL">Belgium</option>
                                        <option value="BLZ">Belize</option>
                                        <option value="BEN">Benin</option>
                                        <option value="BMU">Bermuda</option>
                                        <option value="BTN">Bhutan</option>
                                        <option value="BOL">Bolivia, Plurinational State of</option>
                                        <option value="BES">Bonaire, Sint Eustatius and Saba</option>
                                        <option value="BIH">Bosnia and Herzegovina</option>
                                        <option value="BWA">Botswana</option>
                                        <option value="BVT">Bouvet Island</option>
                                        <option value="BRA">Brazil</option>
                                        <option value="IOT">British Indian Ocean Territory</option>
                                        <option value="BRN">Brunei Darussalam</option>
                                        <option value="BGR">Bulgaria</option>
                                        <option value="BFA">Burkina Faso</option>
                                        <option value="BDI">Burundi</option>
                                        <option value="KHM">Cambodia</option>
                                        <option value="CMR">Cameroon</option>
                                        <option value="CAN">Canada</option>
                                        <option value="CPV">Cape Verde</option>
                                        <option value="CYM">Cayman Islands</option>
                                        <option value="CAF">Central African Republic</option>
                                        <option value="TCD">Chad</option>
                                        <option value="CHL">Chile</option>
                                        <option value="CHN">China</option>
                                        <option value="CXR">Christmas Island</option>
                                        <option value="CCK">Cocos (Keeling) Islands</option>
                                        <option value="COL">Colombia</option>
                                        <option value="COM">Comoros</option>
                                        <option value="COG">Congo</option>
                                        <option value="COD">Congo, the Democratic Republic of the</option>
                                        <option value="COK">Cook Islands</option>
                                        <option value="CRI">Costa Rica</option>
                                        <option value="CIV">Côte d'Ivoire</option>
                                        <option value="HRV">Croatia</option>
                                        <option value="CUB">Cuba</option>
                                        <option value="CUW">Curaçao</option>
                                        <option value="CYP">Cyprus</option>
                                        <option value="CZE">Czech Republic</option>
                                        <option value="DNK">Denmark</option>
                                        <option value="DJI">Djibouti</option>
                                        <option value="DMA">Dominica</option>
                                        <option value="DOM">Dominican Republic</option>
                                        <option value="ECU">Ecuador</option>
                                        <option value="EGY">Egypt</option>
                                        <option value="SLV">El Salvador</option>
                                        <option value="GNQ">Equatorial Guinea</option>
                                        <option value="ERI">Eritrea</option>
                                        <option value="EST">Estonia</option>
                                        <option value="ETH">Ethiopia</option>
                                        <option value="FLK">Falkland Islands (Malvinas)</option>
                                        <option value="FRO">Faroe Islands</option>
                                        <option value="FJI">Fiji</option>
                                        <option value="FIN">Finland</option>
                                        <option value="FRA">France</option>
                                        <option value="GUF">French Guiana</option>
                                        <option value="PYF">French Polynesia</option>
                                        <option value="ATF">French Southern Territories</option>
                                        <option value="GAB">Gabon</option>
                                        <option value="GMB">Gambia</option>
                                        <option value="GEO">Georgia</option>
                                        <option value="DEU">Germany</option>
                                        <option value="GHA">Ghana</option>
                                        <option value="GIB">Gibraltar</option>
                                        <option value="GRC">Greece</option>
                                        <option value="GRL">Greenland</option>
                                        <option value="GRD">Grenada</option>
                                        <option value="GLP">Guadeloupe</option>
                                        <option value="GUM">Guam</option>
                                        <option value="GTM">Guatemala</option>
                                        <option value="GGY">Guernsey</option>
                                        <option value="GIN">Guinea</option>
                                        <option value="GNB">Guinea-Bissau</option>
                                        <option value="GUY">Guyana</option>
                                        <option value="HTI">Haiti</option>
                                        <option value="HMD">Heard Island and McDonald Islands</option>
                                        <option value="VAT">Holy See (Vatican City State)</option>
                                        <option value="HND">Honduras</option>
                                        <option value="HKG">Hong Kong</option>
                                        <option value="HUN">Hungary</option>
                                        <option value="ISL">Iceland</option>
                                        <option value="IND">India</option>
                                        <option value="IDN">Indonesia</option>
                                        <option value="IRN">Iran, Islamic Republic of</option>
                                        <option value="IRQ">Iraq</option>
                                        <option value="IRL">Ireland</option>
                                        <option value="IMN">Isle of Man</option>
                                        <option value="ISR">Israel</option>
                                        <option value="ITA">Italy</option>
                                        <option value="JAM">Jamaica</option>
                                        <option value="JPN">Japan</option>
                                        <option value="JEY">Jersey</option>
                                        <option value="JOR">Jordan</option>
                                        <option value="KAZ">Kazakhstan</option>
                                        <option value="KEN">Kenya</option>
                                        <option value="KIR">Kiribati</option>
                                        <option value="PRK">Korea, Democratic People's Republic of</option>
                                        <option value="KOR">Korea, Republic of</option>
                                        <option value="KWT">Kuwait</option>
                                        <option value="KGZ">Kyrgyzstan</option>
                                        <option value="LAO">Lao People's Democratic Republic</option>
                                        <option value="LVA">Latvia</option>
                                        <option value="LBN">Lebanon</option>
                                        <option value="LSO">Lesotho</option>
                                        <option value="LBR">Liberia</option>
                                        <option value="LBY">Libya</option>
                                        <option value="LIE">Liechtenstein</option>
                                        <option value="LTU">Lithuania</option>
                                        <option value="LUX">Luxembourg</option>
                                        <option value="MAC">Macao</option>
                                        <option value="MKD">Macedonia, the former Yugoslav Republic of</option>
                                        <option value="MDG">Madagascar</option>
                                        <option value="MWI">Malawi</option>
                                        <option value="MYS">Malaysia</option>
                                        <option value="MDV">Maldives</option>
                                        <option value="MLI">Mali</option>
                                        <option value="MLT">Malta</option>
                                        <option value="MHL">Marshall Islands</option>
                                        <option value="MTQ">Martinique</option>
                                        <option value="MRT">Mauritania</option>
                                        <option value="MUS">Mauritius</option>
                                        <option value="MYT">Mayotte</option>
                                        <option value="MEX">Mexico</option>
                                        <option value="FSM">Micronesia, Federated States of</option>
                                        <option value="MDA">Moldova, Republic of</option>
                                        <option value="MCO">Monaco</option>
                                        <option value="MNG">Mongolia</option>
                                        <option value="MNE">Montenegro</option>
                                        <option value="MSR">Montserrat</option>
                                        <option value="MAR">Morocco</option>
                                        <option value="MOZ">Mozambique</option>
                                        <option value="MMR">Myanmar</option>
                                        <option value="NAM">Namibia</option>
                                        <option value="NRU">Nauru</option>
                                        <option value="NPL">Nepal</option>
                                        <option value="NLD">Netherlands</option>
                                        <option value="NCL">New Caledonia</option>
                                        <option value="NZL">New Zealand</option>
                                        <option value="NIC">Nicaragua</option>
                                        <option value="NER">Niger</option>
                                        <option value="NGA">Nigeria</option>
                                        <option value="NIU">Niue</option>
                                        <option value="NFK">Norfolk Island</option>
                                        <option value="MNP">Northern Mariana Islands</option>
                                        <option value="NOR">Norway</option>
                                        <option value="OMN">Oman</option>
                                        <option value="PAK">Pakistan</option>
                                        <option value="PLW">Palau</option>
                                        <option value="PSE">Palestinian Territory, Occupied</option>
                                        <option value="PAN">Panama</option>
                                        <option value="PNG">Papua New Guinea</option>
                                        <option value="PRY">Paraguay</option>
                                        <option value="PER">Peru</option>
                                        <option value="PHL">Philippines</option>
                                        <option value="PCN">Pitcairn</option>
                                        <option value="POL">Poland</option>
                                        <option value="PRT">Portugal</option>
                                        <option value="PRI">Puerto Rico</option>
                                        <option value="QAT">Qatar</option>
                                        <option value="REU">Réunion</option>
                                        <option value="ROU">Romania</option>
                                        <option value="RUS">Russian Federation</option>
                                        <option value="RWA">Rwanda</option>
                                        <option value="BLM">Saint Barthélemy</option>
                                        <option value="SHN">Saint Helena, Ascension and Tristan da Cunha</option>
                                        <option value="KNA">Saint Kitts and Nevis</option>
                                        <option value="LCA">Saint Lucia</option>
                                        <option value="MAF">Saint Martin (French part)</option>
                                        <option value="SPM">Saint Pierre and Miquelon</option>
                                        <option value="VCT">Saint Vincent and the Grenadines</option>
                                        <option value="WSM">Samoa</option>
                                        <option value="SMR">San Marino</option>
                                        <option value="STP">Sao Tome and Principe</option>
                                        <option value="SAU">Saudi Arabia</option>
                                        <option value="SEN">Senegal</option>
                                        <option value="SRB">Serbia</option>
                                        <option value="SYC">Seychelles</option>
                                        <option value="SLE">Sierra Leone</option>
                                        <option value="SGP">Singapore</option>
                                        <option value="SXM">Sint Maarten (Dutch part)</option>
                                        <option value="SVK">Slovakia</option>
                                        <option value="SVN">Slovenia</option>
                                        <option value="SLB">Solomon Islands</option>
                                        <option value="SOM">Somalia</option>
                                        <option value="ZAF">South Africa</option>
                                        <option value="SGS">South Georgia and the South Sandwich Islands</option>
                                        <option value="SSD">South Sudan</option>
                                        <option value="ESP">Spain</option>
                                        <option value="LKA">Sri Lanka</option>
                                        <option value="SDN">Sudan</option>
                                        <option value="SUR">Suriname</option>
                                        <option value="SJM">Svalbard and Jan Mayen</option>
                                        <option value="SWZ">Swaziland</option>
                                        <option value="SWE">Sweden</option>
                                        <option value="CHE">Switzerland</option>
                                        <option value="SYR">Syrian Arab Republic</option>
                                        <option value="TWN">Taiwan, Province of China</option>
                                        <option value="TJK">Tajikistan</option>
                                        <option value="TZA">Tanzania, United Republic of</option>
                                        <option value="THA">Thailand</option>
                                        <option value="TLS">Timor-Leste</option>
                                        <option value="TGO">Togo</option>
                                        <option value="TKL">Tokelau</option>
                                        <option value="TON">Tonga</option>
                                        <option value="TTO">Trinidad and Tobago</option>
                                        <option value="TUN">Tunisia</option>
                                        <option value="TUR">Turkey</option>
                                        <option value="TKM">Turkmenistan</option>
                                        <option value="TCA">Turks and Caicos Islands</option>
                                        <option value="TUV">Tuvalu</option>
                                        <option value="UGA">Uganda</option>
                                        <option value="UKR">Ukraine</option>
                                        <option value="ARE">United Arab Emirates</option>
                                        <option value="GBR">United Kingdom</option>
                                        <option value="USA">United States</option>
                                        <option value="UMI">United States Minor Outlying Islands</option>
                                        <option value="URY">Uruguay</option>
                                        <option value="UZB">Uzbekistan</option>
                                        <option value="VUT">Vanuatu</option>
                                        <option value="VEN">Venezuela, Bolivarian Republic of</option>
                                        <option value="VNM">Viet Nam</option>
                                        <option value="VGB">Virgin Islands, British</option>
                                        <option value="VIR">Virgin Islands, U.S.</option>
                                        <option value="WLF">Wallis and Futuna</option>
                                        <option value="ESH">Western Sahara</option>
                                        <option value="YEM">Yemen</option>
                                        <option value="ZMB">Zambia</option>
                                        <option value="ZWE">Zimbabwe</option>
                                    </select>
                                </div>
                                {/* <!--end::Select--> */}
                            </div>
                        </div>

                    </div>


                    <div className="my-10 h3 font-weight-bold text-dark">User Investment Profile</div>

                    {/* <!--begin::Input--> */}
                    <div className="form-group">
                        <label>Approximate annual income (USD)</label>
                        <input 
                            type="number" 
                            defaultValue={userData?.tab3?.investmentData?.annualIncome}
                            className="form-control form-control-solid form-control-lg" 
                            name="annualIncome"
                        />
                    </div>
                    {/* <!--end::Input--> */}

                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Liquid net worth (USD)</label>
                                <input 
                                    type="number" 
                                    defaultValue={userData?.tab3?.investmentData?.networthLiquid}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="networthLiquid"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Select--> */}
                            <div className="form-group">
                                <label>Total net worth (USD)</label>
                                <input 
                                    type="number" 
                                    defaultValue={userData?.tab3?.investmentData?.networthTotal}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="networthTotal"
                                />
                            </div>
                            {/* <!--end::Select--> */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Investment objectives</label>
                                <select 
                                    name="investmentObjectives" 
                                    defaultValue={userData?.tab3?.investmentData?.investmentObjectives}
                                    className="form-control form-control-solid form-control-lg"
                                >
                                    <option value="">Select</option>
                                    <option value="LONG_TERM">Long–term buy & hold investing</option>
                                    <option value="INFREQUENT">Trading infrequently when I see an opportunity</option>
                                    <option value="FREQUENT">Frequent trader, depending on the market</option>
                                    <option value="ACTIVE_DAILY">Active trader, daily trader</option>
                                    <option value="NEW">New to investing</option>
                                </select>
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Select--> */}
                            <div className="form-group">
                                
                                <label>Investment experience</label>
                                <select 
                                    name="investmentExperience" 
                                    defaultValue={userData?.tab3?.investmentData?.investmentExperience}
                                    className="form-control form-control-solid form-control-lg"
                                >
                                    <option value="">Select</option>
                                    <option value="NONE">None</option>
                                    <option value="YRS1_2">1–2 years</option>
                                    <option value="YRS_3_5">3–5 years</option>
                                    <option value="YRS_5_10">5–10 years</option>
                                    <option value="YRS_10">10+ years</option>
                                </select>
                            </div>
                            {/* <!--end::Select--> */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                
                                <label>Risk tolerance</label>
                                <select 
                                    name="riskTolerance" 
                                    defaultValue={userData?.tab3?.investmentData?.riskTolerance}
                                    className="form-control form-control-solid form-control-lg"
                                >
                                    <option value="">Select</option>
                                    <option value="LOW">Low Risk</option>
                                    <option value="MODERATE">Moderate Risk</option>
                                    <option value="SPECULATION">Speculative Risk</option>
                                    <option value="HIGH">High Risk</option>
                                </select>
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Select--> */}
                            <div className="form-group">
                                <label>User's tax rate</label>
                                <input 
                                    type="number" 
                                    defaultValue={userData?.tab3?.investmentData?.taxRate}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="taxRate"
                                />
                            </div>
                            {/* <!--end::Select--> */}
                        </div>
                    </div>

                    <div className="my-10 h3 font-weight-bold text-dark">User Compliance & AML</div>

                    <div className="row">
                        <div className="col-xl-12">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Expected annual monetary transfer total</label>
                                <input 
                                    type="number" 
                                    defaultValue={userData?.tab3?.complianceData?.transferTotalExpected}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="transferTotalExpected"
                                />
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-6">
                            {/* <!--begin::Select--> */}
                            <div className="form-group">
                                
                                <label>Expected transfers per month count</label>
                                <input 
                                    type="number" 
                                    defaultValue={userData?.tab3?.complianceData?.transferFrequencyPerMonth}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="transferFrequencyPerMonth"
                                />
                            </div>
                            {/* <!--end::Select--> */}
                        </div>
                        <div className="col-xl-6">
                            {/* <!--begin::Select--> */}
                            <div className="form-group">
                                <label>Past 12 months investment count</label>
                                <input 
                                    type="number" 
                                    defaultValue={userData?.tab3?.complianceData?.investmentHistory12M}
                                    className="form-control form-control-solid form-control-lg" 
                                    name="investmentHistory12M"
                                />
                            </div>
                            {/* <!--end::Select--> */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-12">
                            {/* <!--begin::Input--> */}
                            <div className="form-group">
                                <label>Funding sources for account</label>
                                <select 
                                    name="fundingSources" 
                                    defaultValue={userData?.tab3?.complianceData?.fundingSources ?? [] }
                                    className="form-control form-control-solid form-control-lg"
                                    multiple
                                >
                                    <option value="">Select</option>
                                    <option value="EMP">Employment</option>
                                    <option value="GIFT">Gift</option>
                                    <option value="TRUST">Inheritance / Trust</option>
                                    <option value="INVESTMENT">Investment Proceeds</option>
                                    <option value="SAVINGS">Savings</option>
                                    <option value="RETIRE">Retirement Funds</option>
                                    <option value="GAMBLING">Gambling</option>
                                    <option value="LEGAL">Legal Settlement</option>
                                    <option value="FAMILY">Spouse / Parent</option>
                                    <option value="UNEMP">Unemployment / Disability</option>
                                    <option value="ROLLOVER">Rollover</option>
                                    <option value="RENT">Rental Income</option>
                                    <option value="SALE">Sale of Business</option>
                                    <option value="INSURANCE">Insurance Proceeds</option>
                                </select>
                            </div>
                            {/* <!--end::Input--> */}
                        </div>
                    </div>

                    {/* <!--begin: Wizard Actions--> */}
                    <div className="d-flex justify-content-between border-top mt-5 pt-10">
                        <div className="mr-2">
                            <button
                                onClick={_ => setTab(2)} 
                                type="button" 
                                className="btn btn-light-primary font-weight-bolder text-uppercase px-9 py-4">Previous</button>
                        </div>
                        <div>
                            <button type="submit" className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4">Next</button>
                        </div>
                    </div>
                    {/* <!--end: Wizard Actions--> */}
                </div>
            </form>
}

export default Tab3;